import { render } from "./ReplyBestAnswerIcon.vue?vue&type=template&id=a4732234&ts=true"
import script from "./ReplyBestAnswerIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReplyBestAnswerIcon.vue?vue&type=script&setup=true&lang=ts"

import "./ReplyBestAnswerIcon.vue?vue&type=style&index=0&id=a4732234&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/communityTalk/reply/ReplyBestAnswerIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a4732234"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a4732234', __exports__)) {
    api.reload('a4732234', __exports__)
  }
  
  module.hot.accept("./ReplyBestAnswerIcon.vue?vue&type=template&id=a4732234&ts=true", () => {
    api.rerender('a4732234', render)
  })

}


export default __exports__